/* eslint-disable max-len */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CardItemsSavingMoney from 'lib/apps/catalogue/components/YourSavingsHubPage/CardItemsSavingMoney';
import { generateCouponCardContent, generateSmartPassCardContent, generatePricePromiseContent } from 'lib/apps/catalogue/utils/cardContentGenerators';
import { msg } from 'api';

class SavingMoneySection extends PureComponent {
  static propTypes = {
    couponsToUse: PropTypes.string.isRequired,
    couponsSumSavings: PropTypes.string.isRequired,
    smartPassType: PropTypes.string.isRequired,
    pricePromiseSum: PropTypes.string.isRequired,
    pricePromiseVoucher: PropTypes.string.isRequired,
  };

  generateCardContent = () => {
    const {
      couponsToUse,
      couponsSumSavings,
      smartPassType,
      pricePromiseSum,
      pricePromiseVoucher,
    } = this.props;
    const cardContent = {
      couponCard: {
        ...generateCouponCardContent(couponsToUse, couponsSumSavings),
        icon: 'grape_coupon.svg',
        text: `${msg.yourSavingsHub.couponCardText}`,

      },
      smartPassCard: {
        ...generateSmartPassCardContent(smartPassType),
        icon: 'old_smart_pass_icon.svg',
        text: `${msg.yourSavingsHub.smartPassText}`,
      },
      pricePromise: {
        ...generatePricePromiseContent(pricePromiseSum, pricePromiseVoucher),
        icon: 'grape_price_promise.svg',
        text: `${msg.yourSavingsHub.pricePromiseText}`,
      },
    };

    return cardContent;
  }

  render() {
    const cardContent = this.generateCardContent();
    const { smartPassType } = this.props;
    return (
<section className="saving-money-section">
    <h2 className="saving-money__title">Ways to save</h2>
    <div className="saving-money__card-container">
      <div className="saving-money__coupons-card">
        <CardItemsSavingMoney
          cardContent={cardContent.couponCard}
          buttonLink={cardContent.couponCard.buttonLinkCouponCard}
          rightArrowIcon="white_right_arrow.svg"
        />
      </div>
      <div className="saving-money__smartpass-card">
        <CardItemsSavingMoney
          cardContent={cardContent.smartPassCard}
          buttonLink={msg.yourSavingsHub.buttonLinkSmartPass}
          smartPassType={smartPassType}
          rightArrowIcon="white_right_arrow.svg"
        />
      </div>
      <div className="saving-money__pricepromise-card">
        <CardItemsSavingMoney
          cardContent={cardContent.pricePromise}
          buttonLink={msg.yourSavingsHub.buttonLinkPromise}
          rightArrowIcon="white_right_arrow.svg"
          whiteCopy="white_copy.svg"
        />
      </div>
    </div>
  </section>
    );
  }
}

export default SavingMoneySection;
